import React, { memo } from "react";

interface BadgeType {
  count: number;
}

const Badge = ({ count }: BadgeType) => {
  return (
    <div
      className={[
        "Badge",
        "py-1 px-1.5 rounded-xl text-center font-bold",
        "text-[length:var(--fontSize-sm)] leading-none",
        "bg-destructive text-destructive-foreground",
        "inline-block absolute z-[1] ml-1.5 -top-1",
        "min-w-5 min-h-5"
      ].join(" ")}
    >
      {count}
    </div>
  );
};

export default memo<BadgeType>(Badge);
